import React from 'react';
import { Link } from 'react-router-dom';

function ZukuenftigeSkifreizeit() {
  return (
    <div className="app-container">
      <div className="content">
        <h1 className="title">Skifreizeit Februar 2026</h1>
        
        {/* Flyer Image */}
        <div className="flyer-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src="/images/pitztal_2026.png" alt="Flyer Skifreizeit Februar 2026" className="flyer-image" style={{ maxWidth: '40%', height: 'auto', marginBottom: '3rem' }} />
        </div>
        
        {/* Event Description */}
        <p className="text">
          Die Skifreizeit im Februar 2026 war ein voller Erfolg!
          Auch dieses Jahr ging es wieder ins wunderschöne Pitztal mit perfekten Pisten für Anfänger und Fortgeschrittene.
        </p>

        <p className="text">
          Weitere Impressionen findet ihr auf unseren Social-Media-Kanälen.
        </p>

        {/* Download Button */}
        <div className="download-section" style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <a href="/images/pitztal_2026.pdf" download className="download" style={{ padding: '0.75rem 1.5rem', backgroundColor: 'var(--primary-color)', color: '#fff', borderRadius: '8px', textDecoration: 'none', transition: 'background 0.3s, transform 0.3s' }}>
            Flyer herunterladen
          </a>
          <Link to="/freizeit" className="download" style={{ padding: '0.75rem 1.5rem', backgroundColor: 'var(--accent-color)', color: '#fff', borderRadius: '8px', textDecoration: 'none', transition: 'background 0.3s, transform 0.3s' }}>
            Zurück zu den Ausflügen
          </Link>
        </div>

       


      </div>
    </div>
  );
}

export default ZukuenftigeSkifreizeit;
